@if (loadingService.isLoading()) {
  <div class="app-loading-track" aria-busy="true" aria-live="polite">
    <div class="app-loading-bar"></div>
  </div>
}
<router-outlet />
<ngx-sonner-toaster position="bottom-right" theme="system" richColors />